import { useState } from 'react';
import { NavSectionsEnum } from '../../types/NavSectionsEnum.d';

const HASH_SECTIONS = [
  {
    to: 'home',
    key: NavSectionsEnum.HOME,
    pathSp: 'Inicio',
    pathEn: 'Home',
    icon: 'uil-estate',
  },
  {
    to: 'about',
    key: NavSectionsEnum.ABOUT,
    pathSp: 'Sobre Mi',
    pathEn: 'About Me',
    icon: 'uil-user',
  },
  {
    to: 'skills',
    key: NavSectionsEnum.SKILLS,
    pathSp: 'Habilidades',
    pathEn: 'Skills',
    icon: 'uil-file-alt',
  },
  {
    to: 'Studies',
    key: NavSectionsEnum.STUDIES,
    pathSp: 'Estudios',
    pathEn: 'Studies',
    icon: 'uil-book-alt',
  },
  {
    to: 'portfolio',
    key: NavSectionsEnum.PORTFOLIO,
    pathSp: 'Portfolio',
    pathEn: 'Portfolio',
    icon: 'uil-scenery',
  },
  {
    to: 'contact',
    key: NavSectionsEnum.CONTACT,
    pathSp: 'Contacto',
    pathEn: 'Contact',
    icon: 'uil-message',
  },
];

export const useNav = () => {
  window.addEventListener('scroll', function () {
    const header = document.querySelector('.header');

    if (this.scrollY >= 80) header?.classList.add('scroll-header');
    else header?.classList.remove('scroll-header');
  });

  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState('#home');

  const currentURL = window.location;

  return {
    Toggle,
    showMenu,
    activeNav,
    setActiveNav,
    currentURL,
    HASH_SECTIONS,
  };
};
